import { render, staticRenderFns } from "./sys-role.vue?vue&type=template&id=133fb9e3&scoped=true&"
import script from "./sys-role.vue?vue&type=script&lang=js&"
export * from "./sys-role.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133fb9e3",
  null
  
)

export default component.exports